var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PPage',{staticClass:"ErrorPage"},[_c('div',{staticClass:"ErrorPage__Wrapper"},[_c('h2',{staticClass:"ErrorPage__Title"},[_vm._v("404 Error")]),_vm._v(" "),_c('p',{staticClass:"ErrorPage__Message"},[_vm._v("お探しのページがみつかりません！")])])])}
var staticRenderFns = []

export { render, staticRenderFns }